

































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { FollowingStatistic } from "@scrile/api-provider/dist/api/FollowingsProvider";

export default defineComponent({
  name: "ProfileStatisticView",
  props: {
    userId: { type: String, required: true },
    followingStatistic: { type: Object as PropType<FollowingStatistic | null>, default: null },
    postsStatistic: { type: Number, required: true },
    likesStatistic: { type: Number, required: true },
    showFollowing: { type: Boolean, default: true },
    showFollowers: { type: Boolean, default: true },
    showLikes: { type: Boolean, default: true },
    hidePostsStats: { type: Boolean, default: false },
  },
  setup(props, { root }) {
    const amountFollowers = computed(() => props.followingStatistic?.followerCount ?? 0);
    const amountFollowing = computed(() => props.followingStatistic?.followingCount ?? 0);
    const formattedPostsStats = computed(() => props.postsStatistic);

    const handleScrollToFeed = () => {
      const el = root.$el.querySelector(".content-feed-view");
      el && el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };
    return { amountFollowers, amountFollowing, formattedPostsStats, handleScrollToFeed };
  },
});
